// extracted by mini-css-extract-plugin
export var animated_background = "placeholder_ad-module--animated_background--b9e66";
export var loading_text = "placeholder_ad-module--loading_text--eef51";
export var placeHolderShimmer = "placeholder_ad-module--placeHolderShimmer--ae2c6";
export var placeholder = "placeholder_ad-module--placeholder--6a7f9";